module.exports = __webpack_public_path__ + "img/2025-03-12b_3.9cadfb9e.jpg";